
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PackageData } from "@/pages/CreatePackage";
import { Trash2, Calendar, Clock, DollarSign } from "lucide-react";

interface PackageToursListProps {
  tours: PackageData['tours'];
  onRemoveTour: (index: number) => void;
}

export const PackageToursList = ({ tours, onRemoveTour }: PackageToursListProps) => {
  if (tours.length === 0) {
    return (
      <div className="text-center py-8 border-dashed border-2 rounded-lg">
        <p className="text-gray-500">لم تتم إضافة أي جولات بعد.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">الجولات المضافة</h3>
      {tours.map((tour, index) => (
        <Card key={index} className="bg-gray-50">
          <CardHeader className="flex flex-row items-center justify-between p-4">
            <CardTitle className="text-base">{tour.name}</CardTitle>
            <Button variant="ghost" size="icon" onClick={() => onRemoveTour(index)}>
              <Trash2 className="w-4 h-4 text-red-500" />
            </Button>
          </CardHeader>
          <CardContent className="p-4 pt-0 text-sm text-gray-700 space-y-2">
            <p>{tour.description}</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
              <div className="flex items-center gap-1"><Calendar className="w-3 h-3" /> <strong>التاريخ:</strong> {tour.date}</div>
              <div className="flex items-center gap-1"><Clock className="w-3 h-3" /> <strong>المدة:</strong> {tour.duration}</div>
              <div className="flex items-center gap-1"><DollarSign className="w-3 h-3" /> <strong>السعر:</strong> {tour.price}</div>
            </div>
            {tour.included && tour.included.length > 0 && (
              <div>
                <strong className="text-xs">يشمل:</strong>
                <ul className="list-disc list-inside text-xs">
                  {tour.included.map((item, i) => <li key={i}>{item}</li>)}
                </ul>
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
